import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const EnquiryDashboardDetail = () => {
    const schoolSlugs = JSON.parse(localStorage.getItem("school_slugs")) || [];
    const firstSlug = schoolSlugs.length > 0 ? schoolSlugs[0] : "";
    const isTigpsMain = schoolSlugs.includes("tigps-main");

    const [schools, setSchools] = useState([]);
    const [selectedSchools, setSelectedSchools] = useState([]);
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const [chartData, setChartData] = useState([]);

    const monthOptions = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" }
    ];

    useEffect(() => {
        fetchSchools();
    }, []);

    const fetchSchools = async () => {
        const res = await axios.get(
            `${baseAPIUrl}admin/general_settings/get_schools`,
            { withCredentials: true }
        );

        if (res.data.status === 1) {
            const formatted = res.data.data.map(s => ({
                value: s.school_name,
                label: s.school_name,
                slug: s.school_slug
            }));
            setSchools(formatted);

            if (!isTigpsMain) {
                const cleanSlug = firstSlug.replace("tigps-", "");
                const mySchool = formatted.find(s => s.slug === cleanSlug);
                if (mySchool) {
                    setSelectedSchools([mySchool]);
                }
            }
        }
    };

    useEffect(() => {
        if (!isTigpsMain && selectedSchools.length === 0) {
            return;
        }
        fetchTrend();
    }, [selectedSchools, selectedMonths, year]);

    const fetchTrend = async () => {
        const res = await axios.get(
            `${baseAPIUrl}admin/general_settings/get_schoolwise_monthly_trend`,
            {
                params: {
                    school_name: selectedSchools.map(s => s.value),
                    month: selectedMonths.map(m => m.value),
                    year: year
                },
                withCredentials: true
            }
        );

        if (res.data.status === 1) {
            setChartData(res.data.data);
        }
    };


    // 🔥 Unique months from API
    const months = [...new Set(chartData.map(item => item.month))];

    // 🔥 Unique schools from API data
    const schoolNames = [...new Set(chartData.map(item => item.school_name))];

    const datasets = schoolNames.map((school, index) => ({
        label: school,
        data: months.map(month => {
            const found = chartData.find(
                item => item.school_name === school && item.month === month
            );
            return found ? found.total : 0;
        }),
        borderColor: `hsl(${index * 60}, 70%, 40%)`,
        backgroundColor: `hsl(${index * 60}, 70%, 70%)`,
        tension: 0.4,
    }));


    const data = {
        labels: months,
        datasets: datasets,
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <h1 className="m-0 text-dark">Dashboard</h1>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="mb-4">
                                School-wise Monthly Enquiry Trend
                            </h4>
                             <div className="row mb-4">
                                {isTigpsMain && (
                                    <div className="col-md-4">
                                        <label>Select Schools</label>
                                        <Select
                                            options={schools}
                                            isMulti
                                            value={selectedSchools}
                                            onChange={setSelectedSchools}
                                        />
                                    </div>
                                )}

                                <div className={isTigpsMain ? "col-md-4" : "col-md-6"}>
                                    <label>Select Months</label>
                                    <Select
                                        options={monthOptions}
                                        isMulti
                                        value={selectedMonths}
                                        onChange={setSelectedMonths}
                                    />
                                </div>


                                <div className={isTigpsMain ? "col-md-4" : "col-md-6"}>
                                    <label>Select Year</label>
                                    <select
                                        className="form-control"
                                        value={year}
                                        onChange={(e) => setYear(e.target.value)}
                                    >
                                        {[2024, 2025, 2026].map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <Line data={data} />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EnquiryDashboardDetail;
